<template>
	<div class="form-content">
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="200px">
			<div class="form-row">
				<el-form-item label="姓名：" prop="name" class="form-item">
					<el-input v-model.trim="form.name"></el-input>
				</el-form-item>
				<el-form-item label="身份证号：" prop="zjhm" class="form-item">
					<el-input v-model.trim="form.zjhm"></el-input>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="类别：" prop="lb" class="form-item">
					<el-select v-model.trim="form.lb" style="width: 100%;">
						<el-option
							v-for="item in dictionarys.lbList"
							:key="item.dictcode"
							:label="item.dictionaryValues"
							:value="item.dictcode"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="职称等级：" prop="zc" class="form-item">
					<el-select v-model.trim="form.zc" style="width: 100%;">
						<el-option
							v-for="item in dictionarys.zcList"
							:key="item.dictcode"
							:label="item.dictionaryValues"
							:value="item.dictcode"
						></el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="职称专业：" prop="zy" class="form-item">
					<el-select v-model.trim="form.zy" style="width: 100%;">
						<el-option
							v-for="item in dictionarys.zyList"
							:key="item.dictionaryValues"
							:label="item.dictionaryValues"
							:value="item.dictionaryValues"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="" prop="" class="form-item"></el-form-item>
			</div>
		</el-form>
	</div>
</template>

<script>
	import { getUuid } from '@/utils'
	import { validateIdCard } from '@/utils/jr-validate'
	import { queryCommonDictionary } from '@/api/dictionary/index'

	/**
	 * 专业管理人员表单组件
	 */
	export default {
		name: 'ProfessionalManagement',
		components: {},
		data() {
			return {
				form: {
					// 主键
					id: '',
					// 姓名
					name: '',
					// 证件号码
					zjhm: '',
					// 类别
					lb: '',
					// 职称
					zc: '',
					// 专业
					zy: ''
				},
				rules: {
					name: { required: true, message: '请输入', trigger: 'blur' },
					zjhm: [
						{ required: true, message: '请输入', trigger: 'blur' },
						{ validator: validateIdCard, trigger: 'blur' }
					],
					lb: { required: true, message: '请选择', trigger: 'change' },
					zc: { required: true, message: '请选择', trigger: 'change' },
					zy: { required: true, message: '请选择', trigger: 'change' }
				},

				// 字典集合
				dictionarys: {
					// 类别字典
					lbList: [
						{
							dictionaryValues: '工程技术负责人',
							dictcode: '工程技术负责人'
						},
						{
							dictionaryValues: '财务负责人',
							dictcode: '财务负责人'
						},
						{
							dictionaryValues: '统计人员',
							dictcode: '统计人员'
						},
						{
							dictionaryValues: '专职会计',
							dictcode: '专职会计'
						},
						{
							dictionaryValues: '其他',
							dictcode: '其他'
						}
					],
					// 职称等级字典
					zcList: [
						{
							dictionaryValues: '高级',
							dictcode: '高级'
						},
						{
							dictionaryValues: '中级',
							dictcode: '中级'
						},
						{
							dictionaryValues: '初级',
							dictcode: '初级'
						},
						{
							dictionaryValues: '无',
							dictcode: '无'
						}
					],
					// 职称专业字典
					zyList: []
				}
			}
		},
		created() {},
		mounted() {
			this.handleInitDictionary()
		},
		methods: {
			handleInitDictionary() {
				// 获取职称等级字典
				queryCommonDictionary({ dictionaryId: '7', cxType: '3' }).then(res => {
					this.dictionarys.zyList = res.data
				})
			},
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							if (!this.form.id) {
								// 若无 id 则生成 id ，作为唯一标识
								this.form.id = getUuid()
							}
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';

	.form-content {
		.el-form-item__label {
			font-size: 16px;
		}
		.form-row {
			display: flex;
			gap: 20px;
		}
		.form-item {
			flex: 1;
			margin-bottom: 15px;

			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 15px;
					}
				}
				.el-date-editor--date {
					.el-input__inner {
						padding-left: 40px;
					}
				}
				.el-form-item__label {
					line-height: 28px;
				}
			}
		}
	}
</style>
